/* Xiaomi 2026 · font loader
 *
 * Lifted Google Fonts URL exactly the way the rest of the app loads
 * external fonts. font-display:swap means Manrope / Fraunces appear
 * within ~100ms of page load · system fallback shows in the interim.
 * No render block.
 *
 * Import this once from XiaomiShell.js (mounted only when /xiaomi/* routes match).
 */
export function ensureXiaomiFontsLoaded() {
  if (typeof document === 'undefined') return;
  if (document.getElementById('xiaomi-fonts')) return;  // idempotent

  // Preconnect to fonts.googleapis + fonts.gstatic for faster handshake
  const pre1 = document.createElement('link');
  pre1.rel = 'preconnect';
  pre1.href = 'https://fonts.googleapis.com';
  document.head.appendChild(pre1);

  const pre2 = document.createElement('link');
  pre2.rel = 'preconnect';
  pre2.href = 'https://fonts.gstatic.com';
  pre2.crossOrigin = 'anonymous';
  document.head.appendChild(pre2);

  const fonts = document.createElement('link');
  fonts.id = 'xiaomi-fonts';
  fonts.rel = 'stylesheet';
  fonts.href =
    'https://fonts.googleapis.com/css2' +
    '?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600;9..144,700;9..144,800' +
    '&family=Manrope:wght@400;500;600;700;800' +
    '&display=swap';
  document.head.appendChild(fonts);
}
